const isPositiveNumber = (value?: number | null): value is number =>
	typeof value === 'number' && Number.isFinite(value) && value > 0;

export default isPositiveNumber;
